// ps-list stand-in: no processes visible from a browser. ProcessMonitor
// polls this and, finding no matching process, clears tool-running state —
// which is exactly the behavior we want after a steam:// deep-link launch
// (the web build cannot observe the real game process).
const psList = () => Promise.resolve([]);

module.exports = psList;
module.exports.default = psList;
